import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import "font-awesome/css/font-awesome.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CardTorneo from "./CardTorneo";
import CardNuevoTorneo from "./CardNuevoTorneo";
import Sidebar from "../Sidebar/Sidebar";

import API_URL from "../../localhost/config"; //Importa la variable global

//Toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Home() {
  const [showModal, setShowModal] = useState(false);
  const [equipos, setEquipos] = useState([]);
  const [nuevoEquipo, setNuevoEquipo] = useState("");
  const [nombreTorneo, setNombreTorneo] = useState("");
  const [canchas, setCanchas] = useState([]);
  const [nuevaCancha, setNuevaCancha] = useState("");

  const navigate = useNavigate();

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [torneos, setTorneos] = useState([]);

  // Eliminación torneo
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [torneoAEliminar, setTorneoAEliminar] = useState(null);

  // Imagen
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [torneoImagen, setTorneoImagen] = useState(null);

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  //Loading
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si los datos están cargados

  //Estado para guardar error
  const [error, setError] = useState(null); // Estado para almacenar el error

  const notifySuccess = (mensaje) => {
    toast.success(mensaje, {
      position: "bottom-right",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const notifyWanr = (mensaje) => {
    toast.warn(mensaje, {
      position: "bottom-right",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  useEffect(() => {
    const obtenerTokenLocalStorage = () => {
      return localStorage.getItem("token");
    };

    const tokenAlmacenado = obtenerTokenLocalStorage();
    setToken(tokenAlmacenado);
  }, []);

  const cargarTorneos = async () => {
    try {
      setIsLoading(true);
      const torneosObtenidos = await obtenerTorneos();
      setTorneos(torneosObtenidos);
    } catch (error) {
      console.error("Error al cargar los torneos:", error);
      setError(error.message); // Almacenar el error
    } finally {
      setIsLoading(false); // Marcar como no cargando, independientemente del resultado
    }
  };

  useEffect(() => {
    cargarTorneos();
  }, []);

  // Fetch de los torneos del usuario
  const obtenerTorneos = async () => {
    try {
      const response = await axios.get(`${API_URL}/torneos`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener la lista de torneos:",
        error.response?.data?.message || error.message
      );
      throw error; // Lanzar el error para manejarlo en el componente que llama a obtenerTorneos
    }
  };

  const handleCrearTorneo = async () => {
    if (!nombreTorneo.trim()) {
      // Si no se ha ingresado un nombre de torneo, muestra un error o realiza la acción que consideres adecuada
      setError("Por favor, ingrese un nombre de torneo.");
      return;
    }

    try {
      // Crear torneo
      const responseTorneo = await axios.post(
        `${API_URL}/nuevoTorneo`,
        {
          nombreTorneo,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      notifySuccess("Torneo registrado");
      cargarTorneos(); // Para actualizar en el momento
    } catch (error) {
      console.error(
        "Error al realizar las solicitudes:",
        error.response?.data?.message || error.message
      );
      notifyWanr(error.response?.data?.message || "Error al crear torneo");
    }
    handleClose();
  };

  const handleSeleccionarTorneo = (idTorneo) => {
    // Redirigir al componente Torneo
    navigate(`/torneo/${idTorneo}`);
  };

  const handleEliminarTorneo = (idTorneo) => {
    setShowModalConfirmation(true);
    setTorneoAEliminar(idTorneo);
  };

  const confirmarEliminacion = async (idTorneo) => {
    setShowModalConfirmation(false);

    try {
      // Realizar la solicitud DELETE a la API para eliminar el turno
      await axios.delete(`${API_URL}/deleteTournament/${idTorneo}`);
      // Actualizar la lista de turnos después de eliminar el turno
      const nuevosTorneos = torneos.filter((torneo) => torneo.id !== idTorneo);
      setTorneos(nuevosTorneos);
      notifySuccess("Torneo eliminado correctamente");
    } catch (error) {
      console.error("Error al eliminar el torneo:", error.message);
      setError("Error al eliminar el torneo.");
      notifyWanr(
        error.response?.data?.message || "Error al eliminar el torneo"
      );
    }
  };

  const handleSaveImage = async () => {
    if (!selectedImage) {
      return;
    }

    const bodyImagen = {
      urlImagen: URL.createObjectURL(selectedImage),
      idTorneo: torneoImagen,
    };

    try {
      await axios.post(`${API_URL}/nuevaImagen`, bodyImagen);

      // setSuccessMessage("Equipo agregado exitosamente.");
    } catch (error) {
      setError("Error al agregar el equipo:", error.message);
    }
    // setPostEquipo(Date.now());

    // Después de guardar, cierra el modal.
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setShowImageModal(false);
    // Limpiar el estado de la imagen seleccionada al cerrar el modal
    setSelectedImage(null);
  };

  const handleImageFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
  };

  return (
    <div className="row p-0 g-0">
      <div className="col-sm-auto p-0 g-0 flex-column">
        <Sidebar> </Sidebar>
      </div>
      {error ? (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      ) : null}
      {isLoading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="col-sm p-0 g-0">
          <div className="section-title mt-5">
            <h3>
              Tus <span>torneos</span>
            </h3>
          </div>
          <div className="d-flex flex-wrap g-0 justify-content-center">
            <CardNuevoTorneo handleShow={handleShow} />
            {torneos.map((torneo) => (
              <CardTorneo
                key={torneo.id}
                torneo={torneo}
                handleSeleccionarTorneo={handleSeleccionarTorneo}
                handleEliminarTorneo={handleEliminarTorneo}
                setShowImageModal={setShowImageModal}
                setTorneoImagen={setTorneoImagen}
              />
            ))}
          </div>
        </div>
      )}

      {/* Modal para crear el torneo */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Nuevo Torneo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form">
            {/* Campos del formulario */}
            {error && <div className="alert alert-danger">{error}</div>}

            <Form.Group controlId="nombreTorneo">
              <Form.Control
                type="text"
                placeholder="Ingrese el nombre del torneo"
                onChange={(e) => setNombreTorneo(e.target.value)}
              />
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleCrearTorneo}>
            Crear Torneo
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalConfirmation}
        onHide={() => setShowModalConfirmation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Advertencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Al eliminar este torneo, perderás las fechas, los turnos y los equipos
          creados. ¿Estás seguro de que deseas eliminarlo?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalConfirmation(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={() => confirmarEliminacion(torneoAEliminar)}
          >
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showImageModal} onHide={() => setShowImageModal(false)}>
        <Modal.Body>
          <Form.Group controlId="newImageFile">
            <Form.Label>Seleccionar Nueva Imagen</Form.Label>
            <Form.Control
              type="file"
              label="Seleccionar archivo"
              custom
              onChange={handleImageFileChange}
            />
            {selectedImage && (
              <img
                src={URL.createObjectURL(selectedImage)}
                alt="Preview"
                style={{ marginTop: "10px", maxWidth: "100%" }}
              />
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveImage}>
            Guardar Imagen
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Home;
